import PromotionsActions from '../actions/PromotionsCRUDActions';
import Actions from '../actions/actions';
import { setBusy, setUnBusy, retrievedAll } from './common/commonReducers';
import { PromotionsState } from '../interfaces/promotions';

const initialState: PromotionsState = {
  busy: false,
  isStatusValid: undefined,
  entities: [],
};

export default function promotions(
  state: PromotionsState = initialState,
  action,
) {
  switch (action.type) {
    case PromotionsActions.busyAction:
      return setBusy(state);
    case PromotionsActions.unbusyAction:
      return setUnBusy(state);
    case PromotionsActions.setStatus: {
      const { isStatusValid } = action;
      return {
        ...state,
        busy: false,
        isStatusValid,
      };
    }
    case PromotionsActions.retrievedAllAction:
      return retrievedAll(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
